// extracted by mini-css-extract-plugin
export default {"productGallery":"PH-z","inQuickShop":"QH-z"};